import { makeStyles } from '@material-ui/core/styles';

type Props = {
    isError: boolean;
    dragActive: boolean;
}

export function useIconFieldStyles({ dragActive, isError }: Props) {
    const useStyles = makeStyles((theme) => ({
        label: {
            marginBottom: 10
        },
        inputContainer: {
            border: dragActive ? "2px solid #1976D2" : isError ? "2px dashed #F44336" : "2px dashed #CCCCCC",
            borderRadius: 8,
            padding: 32,
            textAlign: "center",
            cursor: "pointer",
            background: dragActive ? "#F0F8FF" : "#FFFFFF",
            marginBottom: 8,
            transition: "border-color 0.2s, background 0.2s",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 120,
        },
        helperText: {
            marginTop: 4,
            display: "block"
        },
        previewContainer: {
            display: "flex",
            alignItems: "center",
            padding: 16,
            minHeight: 120,
            borderRadius: 8,
            boxShadow: "none",
            borderColor: "#E0E0E0",
        },
        preview: {
            maxHeight: 80,
            maxWidth: 180,
            objectFit: "contain",
            marginRight: 32,
            marginLeft: 8,
        },
        uploadIcon: {
            fontSize: 40,
            color: "#1976D2",
            marginBottom: 8
        },
        link: {
            fontWeight: 500,
            color: "#1976D2",
            fontSize: 16
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}